import {
  ApiFormWrapper,
  FormError,
  FormInput,
  FormSubmitButton,
} from "@holigral/shared/form"
import { invariant } from "@holigral/shared/utils"
import { useChangeEmailMutation, useGetMeQuery } from "./api"
import { useT } from "@/i18n"

export default function ChangeEmail() {
  const { t } = useT("auth")
  const [changeEmail] = useChangeEmailMutation()
  const { data: me, isLoading } = useGetMeQuery()

  if (isLoading) {
    return null
  }

  invariant(me)

  return (
    <ApiFormWrapper
      defaultValues={{
        email: me.email ?? undefined,
      }}
      action={changeEmail}
      successMessage="You have successfully changed your email."
    >
      <FormInput name="email" label="Email" required className="mb-2 w-full" />
      <FormError />
      <FormSubmitButton>{t("changeEmail")}</FormSubmitButton>
    </ApiFormWrapper>
  )
}
